import React, { useState } from "react";
import { contactData } from "../config/dataConfig";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../App.scss";
const ContactUsModal = () => {
  const [sendingMail, setSendingMail] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const sendEmail = async (e) => {
    e.preventDefault();
    setSendingMail(true);

    const form = e.target;
    const formData = new FormData(form);

    try {
      const response = await fetch("https://formspree.io/f/xgvylwav", {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body: formData,
      });

      if (!response.ok) throw new Error("Failed to send email");

      form.reset();
      setSubmitted(true);
      toast.success("Message sent successfully!");
    } catch (error) {
      toast.error("Something went wrong while sending the message.");
      console.error("Form submission error:", error);
    } finally {
      setSendingMail(false);
    }
  };

  return (
    <div id="contact" className="modal fade" role="dialog" aria-hidden="true">
      <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title fw-600 text-7 mx-auto">Contact Us</h5>
            <button type="button" className="btn-close ms-0" data-bs-dismiss="modal" aria-label="Close" />
          </div>
          <div className="modal-body p-4 p-lg-5">
            <p className="lead text-muted text-center mb-5">{contactData.desc}</p>
            <div className="row">
              <div className="col-xl-6">
                {submitted ? (
                  <div className="text-center">
                    <h5 className="fw-bold">Thank you for contacting us!</h5>
                    <p>We'll get back to you as soon as possible.</p>
                  </div>
                ) : (
                  <form id="contact-form" onSubmit={sendEmail}>
                    <input type="hidden" name="_captcha" value="false" />
                    <div className="mb-3">
                      <label className="form-label" htmlFor="name">{contactData.form.nameLable}</label>
                      <input
                        id="name"
                        name="name"
                        type="text"
                        className="form-control border-2"
                        placeholder={contactData.form.namePlaceholder}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label" htmlFor="email">{contactData.form.emailLable}</label>
                      <input
                        id="email"
                        name="email"
                        type="email"
                        className="form-control border-2"
                        placeholder={contactData.form.emailPlaceholder}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label" htmlFor="form-message">{contactData.form.messageLable}</label>
                      <textarea
                        id="form-message"
                        name="message"
                        className="form-control border-2"
                        rows={3}
                        placeholder={contactData.form.messagePlaceholder}
                        required
                      ></textarea>
                    </div>
                    <div className="d-grid mt-4">
                      <button className="btn submit-btn" type="submit" disabled={sendingMail}>
                        {sendingMail ? (
                          <>
                            <span
                              role="status"
                              aria-hidden="true"
                              className="spinner-border spinner-border-sm align-self-center me-2"
                            ></span>
                            Sending...
                          </>
                        ) : (
                          contactData.form.submitButton
                        )}
                      </button>
                    </div>
                  </form>
                )}
              </div>
              <div className="col-xl-6 mt-5 mt-xl-0">
                <div className="row gy-5">
                  {contactData.cards.length &&
                    contactData.cards.map((value, index) => (
                      <div className="col-md-6" key={index}>
                        <div className="featured-box text-center">
                          <div className="featured-box-icon text-primary">
                            <i className={value.icon} style={{ color: "rgb(190, 30, 46)" }} />
                          </div>
                          <h3 className="text-uppercase fw-600">{value.title}</h3>
                          {/* {value.lines.length &&
                            value.lines.map((line, i) => (
                              <p className="mb-0" key={i}>
                                {line}
                              </p>
                            ))} */}
                          {value.lines.map((line, i) => (
                            line.includes("@") ? (
                              <p className="mb-0" key={i}>
                                contact@<br />
                                {line.split("@")[1]}
                              </p>
                            ) : (
                              <p className="mb-0" key={i}>{line}</p>
                            )
                          ))}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsModal;
